/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    SET_PHOTOWALLS(state, photowalls) {
        state.photowalls = photowalls
    },
    REMOVE_RECORD(state, itemId) {
        const sponsorIndex = state.photowalls.findIndex((u) => u.PhotowallId === itemId)
        state.photowalls.splice(photowallIndex, 1)
    },
    SET_SELECTEDPHOTOALBUM(state, SelectedphotowAlbum) {
        state.SelectedphotowAlbum = SelectedphotowAlbum
    },
    REMOVE_SELECTEDPHOTOALBUM(state, itemId) {
        const sponsorIndex = state.SelectedphotowAlbum.findIndex((u) => u.PhotowallId === itemId)
        state.SelectedphotowAlbum.splice(photowallIndex, 1)
    },
}